import { createIcon } from '@chakra-ui/icons';

export const FolderIcon = createIcon({
  displayName: 'FolderIcon',
  viewBox: '0 0 23 19',
  d: 'M23.6429 7.76305H20.75V4.64598C20.75 4.16031 20.367 3.76793 19.8929 3.76793H11.4554L8.31339 0.689272C8.27342 0.650934 8.22083 0.629387 8.16607 0.628906H1.35714C0.883036 0.628906 0.5 1.02128 0.5 1.50696V17.7509C0.5 18.2365 0.883036 18.6289 1.35714 18.6289H20.0536C20.4018 18.6289 20.7179 18.4121 20.8491 18.0801L24.4384 8.97037C24.4786 8.8661 24.5 8.7536 24.5 8.6411C24.5 8.15543 24.117 7.76305 23.6429 7.76305ZM18.8214 7.76305H5.16071C4.8125 7.76305 4.49643 7.97982 4.36518 8.31183L2.42857 13.2289V2.60452H7.47768L10.6813 5.74354H18.8214V7.76305Z',
});
